/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

import { GEOS } from 'core/utils/constants';
/**
 *
 * `HcpAlertTerraformWorkspaces` is a alert template that renders
 * a link to the geo deployment of Terraform.
 *
 *
 * ```
 * <Hcp::Alert::TerraformUnification />
 * ```
 *
 * @class HcpAlertTerraformWorkspaces
 *
 */

export default class HcpAlertTerraformWorkspacesComponent extends Component {
  @service config;

  get deployGeo() {
    return this.config?.app?.deployGeo ?? GEOS.US;
  }
}
